export function NovuIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1.25c-2.62 0-4.75 2.13-4.75 4.75v2.6l-1.15 2.3c-.33.63.13 1.4.85 1.4h10.1c.72 0 1.18-.77.85-1.4l-1.15-2.3V6c0-2.62-2.13-4.75-4.75-4.75Zm-1.75 11.8a1.79 1.79 0 0 0 3.5 0h-3.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
